import React from "react";
import { ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { Article } from "@/lib/content-types";

interface ArticleCardProps {
  article: Article;
  showImages?: boolean;
  onOpen?: (article: Article) => void;
  linkTo?: string;
}

export const ArticleCard: React.FC<ArticleCardProps> = ({ 
  article, 
  showImages = false, 
  onOpen,
  linkTo 
}) => {
  const handleClick = () => {
    if (onOpen) {
      onOpen(article);
    } else if (linkTo) {
      window.location.href = linkTo;
    }
  };

  const handleLinkClick = (e: React.MouseEvent) => {
    e.preventDefault();
    handleClick();
  };

  return (
    <Card className="grid grid-rows-[auto_auto_1fr_auto] group transition-all duration-200 hover:shadow-md">
      <div className="aspect-[16/9] w-full">
        <div 
          className="h-full w-full cursor-pointer transition-opacity duration-200 hover:opacity-70"
          onClick={handleClick}
        >
          {showImages && article.imageUrl ? (
            <img
              src={article.imageUrl}
              alt={article.title}
              className="h-full w-full object-cover object-center rounded-t-lg"
            />
          ) : (
            <div className="h-full w-full bg-muted rounded-t-lg flex items-center justify-center">
              <div className="w-16 h-16 bg-primary/10 rounded-lg flex items-center justify-center">
                <span className="text-2xl font-bold text-primary">
                  {article.category?.charAt(0)?.toUpperCase() || "A"}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
      
      <CardHeader>
        <h3 className="text-lg font-semibold hover:underline md:text-xl">
          <a href="#" onClick={handleLinkClick}>
            {article.title}
          </a>
        </h3>
      </CardHeader>
      
      <CardContent>
        <p className="text-muted-foreground">{article.excerpt}</p>
      </CardContent>
      
      <CardFooter>
        <a
          href="#"
          onClick={handleLinkClick}
          className="flex items-center text-foreground hover:underline"
        >
          Lees meer
          <ArrowRight className="ml-2 size-4" />
        </a>
      </CardFooter>
    </Card>
  );
};

export default ArticleCard;